// export const API="https://maneemfi.com/";
// export const API="https://api.maneecafe.com/";
export const API="https://api.maneespa.com/";
// export const API="http://192.168.100.5:2222";